var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.562,
    height: 20.562,
    viewBox: "0 0 20.562 20.562",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2262",
    "data-name": "Grupo 2262",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2261",
    "data-name": "Grupo 2261"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2061",
    "data-name": "Caminho 2061",
    d: "M252.887,329h-9.213A5.681,5.681,0,0,0,238,334.674v9.213a5.68,5.68,0,0,0,5.674,5.674h9.213a5.681,5.681,0,0,0,5.674-5.674v-9.213A5.681,5.681,0,0,0,252.887,329Zm3.85,14.888a3.854,3.854,0,0,1-3.85,3.85h-9.213a3.854,3.854,0,0,1-3.85-3.85v-9.213a3.854,3.854,0,0,1,3.85-3.85h9.213a3.854,3.854,0,0,1,3.85,3.85Zm0,0",
    transform: "translate(-238 -329)",
    fill: "#63799b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2062",
    "data-name": "Caminho 2062",
    d: "M276.072,361.778a5.3,5.3,0,1,0,5.3,5.3,5.3,5.3,0,0,0-5.3-5.3Zm0,8.771a3.474,3.474,0,1,1,3.474-3.474,3.478,3.478,0,0,1-3.474,3.474Zm0,0",
    transform: "translate(-265.791 -356.795)",
    fill: "#63799b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2063",
    "data-name": "Caminho 2063",
    d: "M334.475,351.6a1.337,1.337,0,1,0,.946.391,1.342,1.342,0,0,0-.946-.391Zm0,0",
    transform: "translate(-318.674 -348.166)",
    fill: "#63799b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.90bd607c902338eec7f30edaa2aa061a.svg";
export { ForwardRef as ReactComponent };